import { useState, useEffect } from 'react'
import { isPedidoFacilSession } from 'modules/pedido-facil/utils/pedido-facil-session'
import cn from 'classnames'
import { CartEmpty, CartListItem } from 'modules/cart/components'
import { CartCheckoutButton } from 'modules/cart/containers'
import type { FC } from 'react'
import { Seller } from 'framework/sellers'
import { useRouter } from 'next/router'
import {useCart, useCartModal, useMercadinho} from 'hooks'
import { ROUTE_CART_INDEX } from 'routes/cart'
import { Button } from 'components/ui'
import { CartListProps } from '.'
import s from './cart-list.module.css'
import { CartListItemProps } from '../cart-list-item'
import Link from 'next/link'

const CartList: FC<CartListProps> = ({
  className = '',
  fromWidget = false,
  itemProps = {},
  items = [],
  isSubscriptionCart = false,
  isExpCart = false,
  jadlogTrackingData,
  showTracking,
  fullHeight = false,
}) => {
  const route = useRouter()
  const [isPedidoFacil, setIsPedidoFacil] = useState(false)
  const { toggleCartModal } = useCartModal()
  const { emptyCart } = useCart()
  const { isMercadinho } = useMercadinho()

  useEffect(() => {
    setIsPedidoFacil(isPedidoFacilSession(route.pathname))
  }, [])

  if (items.length <= 0) {
    return <CartEmpty isSubscriptionCart={isSubscriptionCart} isExpCart={isExpCart} fromWidget={fromWidget} />
  }

  const jadlogSellersIds = jadlogTrackingData ? jadlogTrackingData.map((tracking: any) => tracking?.sellerId) : [];

  const sellers = items
    .map((item) => item?.seller)
    .filter(Boolean)
    .filter((seller, index, self) => self.findIndex((s) => s?.id === seller?.id) === index) as Seller[]

  function pushToCheckout() {
    const basePath =
      isSubscriptionCart ?
      `${ROUTE_CART_INDEX}/assinaturas` :
      isExpCart ?
      `${ROUTE_CART_INDEX}/experiencias` :
      ROUTE_CART_INDEX
    const searchParams = new URLSearchParams()

    if (isMercadinho) {
      searchParams.append('ismercadinho', 'true')
      searchParams.append('subscription', 'false')
      searchParams.append('exp', 'false')
    }
    if (isSubscriptionCart) searchParams.append('subscription', 'true')
    if (isExpCart) searchParams.append('exp', 'true')

    if(!isSubscriptionCart && !isExpCart) {
      searchParams.append('subscription', 'false')
      searchParams.append('exp', 'false')
    }

    const fullPath = `${basePath}?${searchParams.toString()}`

    route.push(fullPath)

    if (fromWidget) {
      toggleCartModal()
    }
  }

  function resetCart() {
    emptyCart()
    route.reload()
  }

  function findTrackingBySellerId(sellerId: number): string {
    if (jadlogTrackingData && Array.isArray(jadlogTrackingData)) {
        const tracking = jadlogTrackingData.find(
            (tracking: any) => tracking && tracking.sellerId === sellerId
        );
        return tracking ? tracking.url : "";
    }
    return "";
  }

  return (
    <>
      <div className={cn(s.root, fullHeight && s.fullHeight, className)}>
        {fromWidget && items.length > 0 && <div className={s.title}>Meu carrinho de compras {isSubscriptionCart && ' - Assinaturas'} {isExpCart && ' - Experiências'}</div>}
        {sellers &&
          sellers.length > 0 &&
          sellers.map((seller) =>
            parseInt(seller?.id, 10) > 0 && items.length ? (
              <section className={s.section}>
                <div className={s.header}>
                  {seller?.name}
                  {(showTracking && jadlogSellersIds.includes(parseInt(seller?.id, 10))) && (
                    <a target='_blank' href={findTrackingBySellerId(parseInt(seller?.id, 10))}><Button className={s.tracking_button}>Acompanhe seu pedido</Button></a>
                  )}
                </div>
                {items.map(
                  (item) =>
                    item?.seller?.id === seller?.id && (
                      <>
                        <CartListItem
                          onlyView={isMercadinho}
                          key={`cart-items-item-${item.id}`}
                          {...({ ...itemProps, item } as CartListItemProps)}
                        />
                      </>
                    ),
                )}
              </section>
            ) : (
              <></>
            ),
          )}
      </div>
      {!fromWidget && (
        <Button onClick={resetCart} variant="ghost">
          Limpar carrinho
        </Button>
      )}
      {fromWidget && !isPedidoFacil &&
        <CartCheckoutButton
          fromWidget={fromWidget}
          onClick={pushToCheckout}
          label={isSubscriptionCart ? 'Ir para o carrinho - assinaturas' : isExpCart ? 'Ir para o carrinho - experiências' : 'Ir para o carrinho'}
        />}
    </>
  )
}

export default CartList
